import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from '../../../models/action/core';
import Translator from '../../../core/i18n';
import { Common } from '../../../core/common';
import imgAnn from '../../../static/images/empty-polling-qr.svg';
import BaseModal from '../../../modal/base-modal/main';
import UpdateModal from './update-modal';
import { addLearningOutComes, deleteLearningOutComes, GetLearningOutcomesList, udpateLearningOutcomes } from '../../../store/actions/learningOutcomes';
import Loading from '../../loading/loading';
import ContentLoader from 'react-content-loader';
import { Confirm } from '../../notification/main';


const T = Translator.create();
let _common: Common;

const CourseLearningOutcomes: React.FC = () => {
    const dispatch = useDispatch();

    const learningOutcomesData = useSelector((state: IAppState) => state.learningOutcomes.learningOutcomesData.results);
    const coursePageActivityId = useSelector((state: IAppState) => state.coursePage.coursePageActivityId);

    const [newOutcome, setNewOutcome] = useState('');
    const [isUpdateModal, setIsUpdateModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState<any>({});
    const [newText, setNewText] = useState('');

    useEffect(() => {
        getLearningOutcomes()
    }, []);

    const getLearningOutcomes = () => {
        dispatch(GetLearningOutcomesList(coursePageActivityId, 0, 10, false, "getLearningOutComes", "get"));
    }

    const handleAddOutcomeClick = () => {
        dispatch(addLearningOutComes(newOutcome, coursePageActivityId, "addLearningOutComes", "set", addLearningOutComesCallback));
    };

    const addLearningOutComesCallback = () => {
        setNewOutcome('');
        setSelectedItem({});
        setNewText('');
        getLearningOutcomes()
    }

    const handleDeleteOutcomeClick = (item: any) => {
        dispatch(deleteLearningOutComes(item.learningOutcomeId, coursePageActivityId, "deleteLearningOutComes", "set", addLearningOutComesCallback));
    }

    const onDeleteClick = (item: any) => {
        Confirm.setConfirm(
            'normal',
            () => handleDeleteOutcomeClick(item),
            T.t('r_confirm_delete_learning_outcome'),
            item.learningOutcomeValue
        );
    }


    const handleUpdateClick = (item: any) => {
        setSelectedItem(item);
        toggleModal();
    }

    const handleTextChange = (e: any) => {
        setNewText(e);
    }

    const handleTextSave = () => {
        dispatch(udpateLearningOutcomes(selectedItem.learningOutcomeId, newText, "updateLearningOutComes", "set", () => { addLearningOutComesCallback(); toggleModal(); setNewText(''); }));
    };

    const toggleModal = () => {
        setIsUpdateModal(!isUpdateModal);
    };

    return (
        <div>
            <span className='cursor-default' style={{ fontWeight: "bold" }}>{T.t('r_learning_outcomes_title')}</span>
            <hr className="bottom-border-2 mx-0" />
            <div className='mt-3'>
                <input
                    type="text"
                    value={newOutcome}
                    onChange={(e) => setNewOutcome(e.target.value)}
                    placeholder={T.t('r_enter_learning_outcome')}
                    className='form-control mb-2'

                />
                <div className='d-flex align-items-center justify-content-end cursor-default'>
                    <button className={`qr-code-tag-square tag-green mb-3`} disabled={newOutcome.trim() === ""} onClick={() => handleAddOutcomeClick()}>
                        <i className="material-icons mr-2">add</i>
                        {T.t('r_select_create')}
                    </button>
                </div>
            </div>

            <Loading spinnerId={'getLearningOutComes'}>
                <div style={{ backgroundColor: '#eeede9' }}>
                    <ContentLoader
                        speed={2}
                        width={'100%'}
                        height={360}
                        viewBox="0 0 1440 160"
                        backgroundColor="#d9d9d9"
                        foregroundColor="#ededed"
                    >
                        <rect x="50" y="6" rx="4" ry="4" width="1440" height="38" />
                        <rect x="8" y="6" rx="4" ry="4" width="35" height="38" />
                        <rect x="50" y="55" rx="4" ry="4" width="1440" height="38" />
                        <rect x="8" y="55" rx="4" ry="4" width="35" height="38" />
                        <rect x="50" y="104" rx="4" ry="4" width="1440" height="38" />
                        <rect x="8" y="104" rx="4" ry="4" width="35" height="38" />
                        <rect x="50" y="153" rx="4" ry="4" width="1440" height="38" />
                        <rect x="8" y="153" rx="4" ry="4" width="35" height="38" />
                    </ContentLoader>
                </div>
            </Loading>
            <div id="getLearningOutComes_Content">
                {(learningOutcomesData && learningOutcomesData.length > 0)
                    ?
                    <div className='d-flex flex-column '>
                        {learningOutcomesData.map((item: any) => {
                            return (
                                <div key={item.learningOutcomeId} className='d-flex align-items-end justify-content-between learning-outcomes-item mt-2'>
                                    <span>{item.learningOutcomeValue}</span>
                                    <div className='d-flex gap-2'>
                                        <button className='qr-code-tag-square tag-gray' onClick={() => handleUpdateClick(item)}>
                                            <i className="material-icons ">edit</i>
                                        </button>
                                        <button className='qr-code-tag-square tag-danger' onClick={() => onDeleteClick(item)}>
                                            <i className="material-icons">delete</i>
                                        </button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    :
                    <div className='d-flex flex-column align-items-center justify-content-center cursor-default'>
                        <img src={imgAnn} alt="Announcement" />
                        <span className='mt-4 text-center'>
                            <b>{T.t('r_learning_outcomes_empty_data')}</b>
                        </span>
                        <span className='text-center'>
                            {T.t('r_learning_outcomes_message')}
                        </span>

                    </div>
                }
            </div>

            <BaseModal
                minWidth={650}
                modalIsOpen={isUpdateModal}
                onClose={toggleModal}
                headerState={"T.t('r_grade_all_assignments_modal_header')"}
                headerIcon={'clock'}
                modalFooter={() => (
                    <div className="modal-footer d-flex justify-content-end">
                        <button type="button" disabled={newText === ""} onClick={handleTextSave} className="btn btn-green">{T.t('r_save_button')}</button>
                    </div>
                )}
            >
                <UpdateModal selectedItem={selectedItem} onChangeText={handleTextChange} />
            </BaseModal>
        </div>
    );
};

export default CourseLearningOutcomes;